<template>
  <v-autocomplete
      :key="selectedFuelType ? selectedFuelType.id : 'reset'"
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.vehicle_fuel_type, 'Combustibil')"
      :items="fuelTypes"
      item-title="name"
      item-value="id"
      name="fuel_type"
      :loading="loading"
      :disabled="loading || isReadonly"
      :readonly="isReadonly"
      v-model="selectedFuelType"
      :rules="[v => !!v || translation(translationList.required, 'Acest camp este obligatoriu')]"
      return-object
  >
    <template v-slot:append-inner>
      <v-tooltip location="top" open-delay="500" open-on-click open-on-hover>
        <template v-slot:activator="{ props }">
           <v-icon v-bind="props" class="cursor-pointer" aria-label="info">
            mdi-information
          </v-icon>
        </template>
        <span>
          <NuxtImg
              src="/images/vehicle/registration_template/template_p3.png"
              class="h-100"
              loading="lazy"
              alt="Registration template"
          />
        </span>
      </v-tooltip>
    </template>
  </v-autocomplete>
</template>


<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useVehicleStore } from '~/plugins/store/vehicle';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type {VehicleFuelType} from "~/types/Vehicle";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => VehicleFuelType | null,
      default: () => null,
      required: false
    },
    isReadonly: Boolean as () => boolean | null,
  },
  emits: ['update:modelValue', 'validation-vehicle-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const vehicleStore = useVehicleStore();
    const translationStore = useTranslationStore();
    const selectedFuelType = ref(modelValue.value ? modelValue.value : null);
    const fuelTypes = ref<VehicleFuelType[]>([]);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref([]);

    onMounted(async () => {
      loading.value = true;
      fuelTypes.value = await vehicleStore.getVehicleFuelTypes();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      loading.value = false;
      const isValid = !!selectedFuelType.value;
      emit('validation-vehicle-status', { field: 'fuel_type', isValid });

      // Listen for validate event
      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'fuel_type') {
          if (!selectedFuelType.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-vehicle-status', { field: 'fuel_type', isValid: true });
          }
        }
      });
    });

    watch(selectedFuelType, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      if (!newValue) {
        selectedFuelType.value = null;
      } else if (newValue.id !== selectedFuelType.value?.id) {
        selectedFuelType.value = newValue;
        error.value = [];
      }
      const isValid = !!newValue;
      emit('validation-vehicle-status', { field: 'fuel_type', isValid });
    });



    return {
      selectedFuelType,
      translationList,
      translation,
      fuelTypes,
      loading,
      error,
    };
  },
});
</script>
